import { groq } from 'next-sanity'

export const createSanityColorProjection = () => {
  return groq`{
    hex,
    "opacity": alpha,
    "rgba": "rgba(" + string(rgb.r) + "," +  string(rgb.g) + "," +  string(rgb.b) + "," + string(rgb.a) +")",
  }`
}
